import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { LISTING_HEAP_IDS } from '../../../../constants';

import styles from './Common.module.scss';

export type OnlineEventLocationProps = {
    onlineEventUrl?: string;
};

export const OnlineEventLocation = ({
    onlineEventUrl,
}: OnlineEventLocationProps) => {
    return (
        <div>
            <p className={styles.locationText}>{gettext('Online event')}</p>
            {onlineEventUrl && (
                <a
                    className={styles.link}
                    href={onlineEventUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-heap-id={LISTING_HEAP_IDS.ONLINE_EVENT_ACCESS_BUTTON}
                >
                    {gettext('Access link')}
                </a>
            )}
        </div>
    );
};
